export default __webpack_public_path__ + "static/media/evo-dropdown.5f8344b2.webp";